function extractErrorMessage(error) {
  let msg = 'Error al verificar el pago. Verifica los datos ingresados.';
  try {
    if (error.response?.data?.detail) {
      const detail = error.response.data.detail;
      if (typeof detail === 'string') {
        msg = detail;
      } else if (Array.isArray(detail)) {
        msg = detail
          .map((err) => {
            if (typeof err === 'string') return err;
            if (err.msg) return `${err.loc?.[err.loc.length - 1] || 'Campo'}: ${err.msg}`;
            return 'Error de validación';
          })
          .join('. ');
      } else if (typeof detail === 'object') {
        msg = detail.message || detail.msg || JSON.stringify(detail);
      }
    } else if (error.response?.data?.message) {
      msg = error.response.data.message;
    } else if (error.message) {
      msg = error.message;
    }
  } catch (e) {
    console.error('Error parsing error message:', e);
    msg = 'Error desconocido al procesar el pago';
  }
  return msg;
}

export { extractErrorMessage };
